<dbw-investor-viewer-accordion
  anchorId="investor-viewer-technique-relation"
  accordionTitle="Technique et relation"
  [expanded]="true">
  <div class="identity-grid">
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">Géré par</span>
      <strong>{{ formatGerePar(gerePar()) }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">Code</span>
      <strong>{{ formatText(viewer().investorCode) }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">InvestisseurId</span>
      <strong>{{ viewer().investorId }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">ArianeId</span>
      <strong>{{ formatText(viewer().arianeId) }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">Origine saisie</span>
      <strong>{{ formatNumber(viewer().originEntryCode) }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">Date de création</span>
      <strong>{{ formatDate(viewer().creationDate) }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">Supprimé</span>
      <strong>{{ formatBoolean(viewer().isDeleted) }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">Origine du contact</span>
      <strong>{{ formatText(viewer().originContactCode) }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">Date d'entrée en relation</span>
      <strong>{{ formatDate(viewer().entryRelationshipDate) }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">Recommandé par</span>
      <strong>{{ formatInvestorLink(viewer().recommendedByInvestorId) }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">Mode de communication</span>
      <strong>{{ formatText(viewer().preferredCommunicationModeCode) }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">Épargne de précaution</span>
      <strong>{{ formatNumber(viewer().emergencySavingsAmount) }}</strong>
    </article>
    <article class="identity-item dbw-card dbw-card--lg">
      <span class="identity-item__label">Épargne mensuelle cible</span>
      <strong>{{ formatNumber(viewer().monthlySavingsTargetAmount) }}</strong>
    </article>
  </div>

  <div class="note-banner dbw-card dbw-card--md">
    <span class="identity-item__label">Notes investisseur</span>
    <strong>{{ formatNotes(viewer().notes) }}</strong>
  </div>
</dbw-investor-viewer-accordion>
